import { IDeleteCentroCustoEnderecoUseCase } from "../../../presentation/useCases/delete/delete_centro_custo_endereco_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteCentroCustoEnderecoUseCase
 */

export class DeleteCentroCustoEnderecoUseCase implements IDeleteCentroCustoEnderecoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async deleteCentroCustoEndereco(idCentroCustoEndereco: number): Promise<void> {
    await this.repository.deleteCentroCustoEndereco(idCentroCustoEndereco);

  }
}
